export default __webpack_public_path__ + "static/quick-add-a3f575a4bb9b17c9ec291431d8a51ebe.jpg";